module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarms2sidedbladesign2018.575055d0.webp";